/// <amd-module name="Dashboards/WidgetHost/MessageComponents/AccessNotSupportedMessage" />
import * as Resources from "Dashboards/WidgetHost/Resources";
import React = require("react");
import { AccessRestrictedImage } from "Reporting/Visuals/VisualMessages/AccessRestrictedImage";
import { VssComponent } from "VSS/Platform/Layout";
import { Link } from "VSSUI/Link";

/** Detail View for blocked widgets content */
export class AccessNotSupportedMessage extends VssComponent {
    public render(): JSX.Element {
        return (
            <div className={"access-not-supported-dialog-content inline-flex-row"}>
                <span className="flex-self-center">
                    <AccessRestrictedImage />
                </span>
                <div className="flex-self-center separate-child-elements">
                    <div className="fontWeightSemiBold">{Resources.DisabledWidget_DialogContentText_DialogSubHeading}</div>
                    <div>{Resources.DisabledWidget_DialogMessage}</div>
                    <Link href="https://go.microsoft.com/fwlink/?linkid=867452" target="_blank">
                        {Resources.DisabledWidget_DialogLicenseTypesLinkText_AzureDevOps}
                    </Link>
                </div>
            </div>
        );
    }
}
